/**
 * Created by Reda Abu Khamdi on 05.11.2026
 */

cleverapps.Tool.crossPromo = {
    disable: {
        flag: "noCrossPromo"
    }
};
